import dayjs from 'dayjs';
import i18next from 'i18next';

export const formatDateForPDF = (dateString: string, format: 'MM.DD.YYYY' | 'MMMM YYYY' | 'YYYY', isExamplePage: boolean) => {
  if (!dateString) {
    return '';
  }

  dayjs.locale(isExamplePage ? 'en' : i18next.language);

  return dayjs(dateString).format(format);
};
